import gql from 'graphql-tag'

const vulnerabilityStatusBreakdownAllFragment = gql`
  fragment VulnerabilityStatusBreakdownAll on VulnerabilityStatusBreakdown {
    reported
    suspicious
    confirmed
    notAProblem
    remediated
    fixed
    autoRemediated
    open
    total
  }
`

export const vulnerabilitySeverityBreakdownAllFragment = gql`
  fragment VulnerabilitySeverityBreakdownAll on VulnerabilitySeverityBreakdown {
    critical {
      ...VulnerabilityStatusBreakdownAll
    }
    high {
      ...VulnerabilityStatusBreakdownAll
    }
    medium {
      ...VulnerabilityStatusBreakdownAll
    }
    low {
      ...VulnerabilityStatusBreakdownAll
    }
    note {
      ...VulnerabilityStatusBreakdownAll
    }
    open
    total
  }
  ${vulnerabilityStatusBreakdownAllFragment}
`
export const applicationFragment = gql`
  fragment Application on Application {
    __typename
    id
    name
    language
    vulnerabilityBreakdown {
      ...VulnerabilitySeverityBreakdownAll
    }
    attackStatus
    hasAProtectedServer
    license {
      expiration
    }
    attackTotal
    role
    url
    linesOfCode
    importance
    technologies
    lastActivity
    online
    archived
    primary
    moduleCount
    violatedCompliancePolicies {
      id
      name
    }
    tags
    customMetadataFields {
      name
      value
      type
      unique
      subfields {
        name
        value
        type
        unique
        isOverriddenByUser
      }
      isOverriddenByUser
    }
    invalidCustomMetadataFields {
      id
      validationType
    }
    scoreGrade
  }

  ${vulnerabilitySeverityBreakdownAllFragment}
`
